import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Tools } from '../../../core/utils/tools';

@Component({
    selector: 'sl-gate-device-code-dialog',
    templateUrl: './gate-device-code-dialog.component.html',
    styleUrls: ['./gate-device-code-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GateDeviceCodeDialogComponent implements AfterViewInit {
    @ViewChild('dmiCodeInput') dmiCodeInput: ElementRef<HTMLInputElement>;

    deviceCode: string;

    private readonly dialogRef = inject(MatDialogRef<GateDeviceCodeDialogComponent>);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    ngAfterViewInit(): void {
        Tools.Utils.startFocusTrap(this.dmiCodeInput.nativeElement, this.changeDetectorRef);
    }

    submit(): void {
        if (!this.deviceCode) {
            return;
        }
        this.dialogRef.close({ deviceCode: this.deviceCode });
    }
}
